export const PhoneTypeEnum = [
  { value: 1, name: 'Residency', labelFrench: 'Maison', labelEnglish: 'Residency' },
  { value: 2, name: 'Mobile', labelFrench: 'Cellulaire', labelEnglish: 'Mobile' },
  { value: 3, name: 'Work', labelFrench: 'Travail', labelEnglish: 'Work' },
  { value: 4, name: 'Pager', labelFrench: 'Téléavertisseur', labelEnglish: 'Pager' },
  { value: 0, name: 'Other', labelFrench: 'Autre', labelEnglish: 'Other' },
];

export const PhoneEnumValue = {
  Residency: 1,
  Mobile: 2,
  Work: 3,
  Pager: 4,
  Other: 0,
};

export default PhoneTypeEnum;
